export function isObject(obj) {
  return obj && typeof obj === 'object' && !Array.isArray(obj);
}

export function removeUndefined(obj) {
  if (typeof obj !== 'object') return obj;
  for (let key in obj) {
    if (typeof obj[key] === 'undefined') {
      delete obj[key];
    } else {
      obj[key] = removeUndefined(obj[key]);
    }
  }
  return obj;
}

export function copyObject(from, to) {
  if (!isObject(from)) {
    console.log('from:', from);
    throw new Error("from is not an object, but a " + typeof from);
  }
  if (!isObject(to)) {
    console.log('to:', to);
    throw new Error("to is not an object, but a " + typeof to);
  }
  let keys = Object.keys(from).concat(Object.keys(to));
  keys.forEach(key => {
    if (from[key] === undefined) {
      delete to[key];
    } else if (Array.isArray(from[key])) {
      to[key] = to[key] || [];
      if (!from[key].length || from[key].length !== to[key].length || typeof from[key][0] !== 'object') {
        to[key] = from[key];
      } else {
        to[key].forEach((obj, idx) => {
          try {
            copyObject(from[key][idx], to[key][idx]);
          } catch (e) {
            e.message = idx + ':' + e.message;
            throw e;
          }
        })
      }
    } else if (isObject(from[key])) {
      to[key] = to[key] || {};
      if (!isObject(to[key])) {
        to[key] = from[key];
      } else {
        try {
          copyObject(from[key], to[key]);
        } catch (e) {
          e.message = key + ':' + e.message;
          throw e;
        }
      }
    } else {
      to[key] = from[key]
    }
  })
}

export function getPathID(method, path) {
  return method.toUpperCase() + path.replace(/\W+/g, '_');
}

export function resolveReference(ref, base) {
  var keys = ref.split('/');
  keys.shift();
  var cur = base;
  keys.forEach(k => cur = cur[k]);
  return cur;
}

export function maybeResolveRef(schema, base) {
  if (!schema || !schema.$ref) return schema;
  return resolveReference(schema.$ref, base);
}

export function decodeFilename(str) {
  return str.replace(/%2E/g, '.');
}

export function encodeFilename(str) {
  return str.replace(/\./g, '%2E');
}

export function range(num) {
  return new Array(num);
}

export function getRelativeFilename(filename, relativeTo) {
  let fParts = filename.split('/');
  let rParts = relativeTo.split('/');
  let firstDifferentIdx = -1;
  fParts = fParts.filter((part, idx) => {
    if (firstDifferentIdx > -1) return true;
    if (part === rParts[idx]) return false;
    firstDifferentIdx = idx;
    return true;
  });
  fParts.unshift('.');
  return fParts.join('/');
}

export function getSchemaProperties(schema, refBase, value={}, subschema=null) {
  if (schema.$ref) schema = resolveReference(schema.$ref, refBase);
  let props = Object.keys(schema.properties || {});
  (schema.allOf || []).forEach(subschema => {
    if (subschema.$ref) subschema = resolveReference(subschema.$ref, refBase);
    let subprops = getSchemaProperties(subschema, refBase);
    props = props.concat(subprops.filter(p => p !== subschema.discriminator));
  });
  if (isObject(value)) {
    let valueProperties = Object.keys(value).filter(k => props.indexOf(k) === -1);
    props = props.concat(valueProperties);
  }
  if (subschema) {
    props = props.concat(getSchemaProperties(subschema, refBase));
  }
  let req = schema.required || [];
  return props.filter((p, idx) => {
    return idx === props.lastIndexOf(p);
  }).sort((p1, p2) => {
    if (p1 === schema.discriminator) return -1;
    if (p2 === schema.discriminator) return 1;
    let i1 = (req.indexOf(p1) + 1) || req.length + 1;
    let i2 = (req.indexOf(p2) + 1) || req.length + 1;
    if (i1 === i2) return 0;
    return i1 < i2 ? -1 : 1;
  });
}

export function getDefaultValueForType(type:string) {
  if (type === 'object') return {};
  else if (type === 'array') return [];
  else if (type === 'string') return '';
  else if (type === 'boolean') return false;
  else if (type === 'number' || type === 'integer') return 0;
}

export function getSchemaFromValue(val) {
  if (typeof val === undefined) return {};
  let type = Array.isArray(val) ? 'array' : typeof val;
  return {type};
}

export function getTypeForSchema(schema, refBase) {
  if (schema.$ref) schema = resolveReference(schema.$ref, refBase);
  if (schema.type) return schema.type;
  if (!schema.allOf) return null;
  for (let i = 0; i < schema.allOf.length; ++i) {
    let subtype = getTypeForSchema(schema.allOf[i], refBase);
    if (subtype) return subtype;
  }
}

export function getPropertySchema(prop, schema, refBase) {
  if (!schema) return;
  if (schema.$ref) schema = resolveReference(schema.$ref, refBase);
  if (schema.properties && schema.properties[prop]) {
    return schema.properties[prop];
  }
  if (schema.allOf) {
    for (let i = 0; i < schema.allOf.length; ++i) {
      let sub = getPropertySchema(prop, schema.allOf[i], refBase);
      if (sub) return sub;
    }
  }
}

export function findType(schema, type, baseSchema=null, key='') {
  if (!schema) return;
  if (key) key += '.';
  baseSchema = baseSchema || schema;
  schema = maybeResolveRef(schema, baseSchema);
  if (schema.type === type) return {schema, key};
  for (let subkey in schema.properties || {}) {
    let subschema = maybeResolveRef(schema.properties[subkey], baseSchema);
    if (subschema.type === type) {
      return {schema: subschema, path: key + subkey};
    }
  }
  for (let subkey in schema.properties || {}) {
    let subschema = maybeResolveRef(schema.properties[subkey], baseSchema);
    let ret = findType(subschema, type, baseSchema, key + subkey);
    if (ret) return ret;
  }
}

export const SCHEMA_TYPES = ['string', 'number', 'boolean', 'array', 'object'];




// WEBPACK FOOTER //
// ./src/app/json-schema-form/util.ts